import { render, staticRenderFns } from "./refresh-btn.vue?vue&type=template&id=6a4815f1&scoped=true"
import script from "./refresh-btn.vue?vue&type=script&lang=js"
export * from "./refresh-btn.vue?vue&type=script&lang=js"
import style0 from "./refresh-btn.vue?vue&type=style&index=0&id=6a4815f1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4815f1",
  null
  
)

export default component.exports